import {Standard} from './standard.model';

export interface StandardFiles extends Standard { ruFileLink?: string; enFileLink?: string; }
export interface StandardFileSelection { type: string; fileId?: string; link?: string; file?: File; }
export const STANDARD_FILE_METADATA = {
  RU_DOC: {field: 'ruDoc', related: ['ruPdf', 'ruFileLink'], link: 'ruFileLink', draft: 'fileRuDoc', selected: 'isNewRuDoc'},
  EN_DOC: {field: 'enDoc', related: ['enPdf', 'enFileLink'], link: 'enFileLink', draft: 'fileEnDoc', selected: 'isNewEnDoc'},
  RU_PPT: {field: 'ruPpt', related: [], link: null, draft: 'fileRuPpt', selected: 'isNewRuPpt'},
  EN_PPT: {field: 'enPpt', related: [], link: null, draft: 'fileEnPpt', selected: 'isNewEnPpt'},
  RU_PDF: {field: 'ruPdf', related: [], link: null, draft: 'fileRuPdf', selected: 'isNewRuPdf'},
  EN_PDF: {field: 'enPdf', related: [], link: null, draft: 'fileEnPdf', selected: 'isNewEnPdf'}
};



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/models/standard-files.model.ts